import { render, staticRenderFns } from "./ExternalDashboardCard.vue?vue&type=template&id=20830d62&"
import script from "./ExternalDashboardCard.vue?vue&type=script&lang=js&"
export * from "./ExternalDashboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports